import globalLogger from '../logger/logger';

const logger = globalLogger.createChannel('capacitor-payload-logging');

export async function withPayloadLogging<Input, Output>(
    name: string,
    pluginCall: (payload: Input) => Promise<Output | null>,
    payload: Input,
): Promise<Output | null> {
    const maxSizeKb = 1024; // 1MB

    const payloadString = JSON.stringify(payload);
    const sizeBytes = new Blob([payloadString]).size;
    const sizeKb = sizeBytes / 1024;

    if (sizeKb >= maxSizeKb) {
        logger.warn('Capacitor: Large payload detected', { sizeKb, pluginName: name, maxSizeKb });
    }

    return pluginCall(payload);
}
